export class UserPermissionRestriction {
    RestrictedToProjectIds: string[];
    RestrictedToEnvironmentIds: string[];
    RestrictedToTenantIds: string[];
    RestrictedToProjectGroupIds: string[];
}

export default UserPermissionRestriction;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/userPermissionRestriction.ts